module.exports = __webpack_public_path__ + "img/trainings-1920_new.869d205a.jpg";